
import Cig from '../util/Cig';

class Sidebar {
	constructor() {
		this.init();

		// vanilla version
		// document.addEventListener('DOMContentLoaded', () => {
		// 	this.init();
		// })
	}

	init = () => {
		this.aboutAuthorWidget();
		this.freeEletterWidget();
	}

	/**
	 * Free E-Letter Widget
	 */
	freeEletterWidget = () => {
		/** show/hide the info blurb about the e-letter */
		if (document.querySelector('.widget_cig_free_e_letters_widget')) {
			document.querySelectorAll('a.eletter-info').forEach((a) => {
				a.addEventListener("click", (event) => {

					// Toggle showing or hiding the element
					if (window.getComputedStyle(a.nextElementSibling).display === 'block') {
						a.nextElementSibling.style.display = `none`;
					} else {
						a.nextElementSibling.style.display = `block`;
					}
				});
			});

			/** make sure at least one checkbox is checked and the email format is valid */
			document.querySelector('#frmSS82').addEventListener("submit", (event) => {

				event.preventDefault();

				const form = document.querySelector('#frmSS82');
				const emailError = document.querySelector('#eletter-error-email');
				const listError = document.querySelector('#eletter-error-list');
				const formDataObject = Cig.serializeObject(form);

				/** if the email is invalid or none of the form options have been selected */
				if (!Cig.isValidEmailAddress(formDataObject.email) || !formDataObject['nlbox[]']) {

					/** reset/hide warnings */
					emailError.style.display = `none`;
					listError.style.display = `none`;

					/** if the email is invalid */
					if (!Cig.isValidEmailAddress(formDataObject.email)) {
						emailError.style.display = `block`;
					}
					/** if the form hasn't been completed */
					if (!formDataObject['nlbox[]']) {
						listError.style.display = `block`;
					}
				}
				else if (Cig.isValidEmailAddress(formDataObject.email) && formDataObject['nlbox[]']) {
					const freeEletterNoSubmit = document.querySelector(`#free-eletter-no-submit`);
					const freeEletterSubmitted = document.querySelector(`#free-eletter-submitted`);

					if (freeEletterNoSubmit) {
						freeEletterNoSubmit.style.display = `none`;
					}

					if (freeEletterSubmitted) {
						freeEletterSubmitted.style.display = `none`;
					}

					return true;
				}

				return false;
			});
		}
	}

	/**
	 * About the Author Widget
	 */
	aboutAuthorWidget = () => {
		const aboutAuthorToggle = document.querySelector('#about-author-toggle');
		if (aboutAuthorToggle) {
			aboutAuthorToggle.addEventListener('click', () => {
				const parent = aboutAuthorToggle.parentNode;
				const content = parent.querySelector('.preview-content');

				if (content.classList.contains('closed')) {
					content.classList.add('open');
					content.classList.remove('closed');
					aboutAuthorToggle.innerHTML = 'show less';
				}
				else {
					content.classList.add('closed');
					content.classList.remove('open');
					aboutAuthorToggle.innerHTML = 'show more';
				}
			});
		}
	}
}

export default Sidebar;
